
import Swiper from 'swiper';


/*------------------------------
旅館
-------------------------------*/
var slider = new Swiper ('.js-main-slider', {
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  speed: 1200,
  parallax: true, //パパラックスさせる
  loop: true,
  pagination: {
    el: '.top-first-contents-slider-fraction',
    type: 'fraction',
  },
});

slider.on('slideChange', function() {
  $(".top-first-contents-slider-pagers__item").removeClass("is-current");
  $(".top-first-contents-slider-pagers__item").eq(slider.realIndex).addClass("is-current");
});

$('.top-first-contents-slider-pagers__item').each(function(i,e) {
  $(this).on('click', function(){
    slider.slideTo(i + 1);
  })
});

// var thumbs = new Swiper('#thumbs01', {
//   centeredSlides: true,
//   spaceBetween: 25,
//   loop: true,
//   slidesPerView: "auto",
//   touchRatio: 0.2,
//   slideToClickedSlide: true,
//   navigation: {
//     nextEl: '.swiper-next01',
//     prevEl: '.swiper-prev01',
//   },
//   breakpoints: {
//     768: {
//       spaceBetween: 10,
//     }
//   }
// });